import { Component, computed, effect, input, model } from "@angular/core"
import { FormValueControl } from "@angular/forms/signals"
import { NgClass } from "@angular/common"
import { MatCheckbox } from "@angular/material/checkbox"
import { Observable } from "rxjs"

@Component({
    selector: "valben-boolean-input",
    templateUrl: "./boolean-input.component.html",
    standalone: true,
    imports: [NgClass, MatCheckbox],
})
export class BooleanInputComponent implements FormValueControl<boolean> {
    value = model(false)
    title = input("")
    error = input(false)
    invalid = input(false)
    disabled = input(false)
    preview = input(false)

    hasError = computed(() => !this.preview() && (this.error() || this.invalid()))
    isDisabled = computed(() => this.disabled() || this.preview())

    key = input("")
    itemObservable = input<(() => Observable<any> | undefined) | undefined>(undefined)
    update = input<((value: any) => void) | undefined>(undefined)

    constructor() {
        effect(onCleanup => {
            const sub = this.itemObservable()?.()?.subscribe(item => {
                if (item == null) return
                const incoming = item[this.key()]
                if (incoming !== undefined && incoming !== this.value()) this.value.set(!!incoming)
            })
            onCleanup(() => sub?.unsubscribe())
        })
    }

    onCheckedChange(checked: boolean): void {
        this.value.set(checked)
        this.update()?.(checked)
    }
}
